/** Parse CSV (RFC 4180, séparateur , ou ;). */
export function parseProspectCsv(text) {
  const normalised = text.replace(/\r\n/g, '\n').replace(/\r/g, '\n');
  const lines = normalised.split('\n').filter((l) => l.length > 0);
  if (lines.length === 0) return { headers: [], rows: [] };

  const parseLine = (line) => {
    const out = [];
    let cell = '';
    let inQ = false;
    for (let j = 0; j < line.length; j++) {
      const c = line[j];
      if (c === '"') {
        if (inQ && line[j + 1] === '"') {
          cell += '"';
          j++;
        } else {
          inQ = !inQ;
          cell += '"';
        }
      } else if ((c === ',' || c === ';') && !inQ) {
        out.push(cell);
        cell = '';
      } else {
        cell += c;
      }
    }
    out.push(cell);
    return out.map((raw) => {
      const trimmed = String(raw).trim();
      if (trimmed.startsWith('"') && trimmed.endsWith('"')) {
        return trimmed.slice(1, -1);
      }
      return trimmed;
    });
  };

  const firstLine = lines[0].replace(/^\uFEFF/, '');
  const headers = parseLine(firstLine);
  const rows = [];
  for (let r = 1; r < lines.length; r++) {
    const line = lines[r];
    if (!line) continue;
    const cells = parseLine(line);
    const row = {};
    headers.forEach((h, i) => {
      row[h] = cells[i] != null ? String(cells[i]).trim() : '';
    });
    rows.push(row);
  }
  return { headers, rows };
}
